export default __webpack_public_path__ + "static/favicon-3babaf73bde936e0e54641b6101a6f19.ico";